import { Component } from '@angular/core';

import { ModalComponent } from '../modal/modal.component';
import { BaseMenuComponent } from './base.menu';

@Component({
    selector: 'inspection-restore-list-menu',
    templateUrl: './restore-list.menu.html',
    standalone: false
})
export class InspectionRestoreListMenuComponent extends BaseMenuComponent {
  constructor(public modal: ModalComponent) {
    super(modal);
  }
}
